import _ from 'lodash'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
// import CurrencyFormat from '../currency-format'
import { useCart, useOrderMethod } from '../../hook'
import useStyles from './dine-in-banner-style'
import Button from '../button'

import ArrowDownIcon from '../../assets/icons/icon_right_arrow.svg'

const DineInBannerView = () => {
  // prepare hook
  const { t } = useTranslation()
  const {
    orderMethod,
  } = useOrderMethod()
  const {
    getCartTotalItemsCount,
    getCart,
  } = useCart()

  const orderMethodCode = useMemo(() => (
    _.get(orderMethod, 'code')
  ), [orderMethod])

  const dineInCommerceChannel = _.get(orderMethod, 'commerceChannel')
  const dineInCart = getCart({ commerceChannel: dineInCommerceChannel })
  const totalItems = getCartTotalItemsCount(dineInCart)

  // style
  const styles = useStyles()

  if (orderMethodCode !== 'dineIn') return null

  return (
    <div className={styles.container}>
      <Button
        text={t('screens.products.dineInOrderPlacedButton', { count: totalItems })}
        navigate="/dine-in-order-placed/"
        iconImage={ArrowDownIcon}
        inline
        className={styles.button}
      />
    </div>
  )
}

export default DineInBannerView
